import { useSyncExternalStore } from 'react'

const subscribe = (onChange: () => void) => {
  document.addEventListener('visibilitychange', onChange)
  return () => document.removeEventListener('visibilitychange', onChange)
}

const getSnapshot = () => document.visibilityState !== 'hidden'

const getServerSnapshot = () => true

/** Whether the browser tab is currently visible; re-renders on every `visibilitychange`. */
export const useIsDocumentVisible = () => useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot)
